import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import TestModeBanner from "@/components/TestModeBanner";
import Index from "./pages/Index";
import Listings from "./pages/Listings";
import ListingDetail from "./pages/ListingDetail";
import CreateListing from "./pages/CreateListing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Messages from "./pages/Messages";
import Profile from "./pages/Profile";
import PublicProfile from "./pages/PublicProfile";
import OrderConfirmed from "./pages/OrderConfirmed";
import AdminDashboard from "./pages/AdminDashboard";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <TestModeBanner />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/annonces" element={<Listings />} />
            <Route path="/annonce/:id" element={<ListingDetail />} />
            <Route path="/vendre" element={<CreateListing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/tableau-de-bord" element={<Dashboard />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/profil" element={<Profile />} />
            <Route path="/vendeur/:userId" element={<PublicProfile />} />
            <Route path="/commande-confirmee" element={<OrderConfirmed />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
